import { createSlice } from "@reduxjs/toolkit";

export const allAccrualsSlice = createSlice({
  name: "allAccruals",
  initialState: {
    is_filtered: false,
    year: null,
    data: [],
  },
  reducers: {
    setAccruals: (state, action) => {
      state.year = action.payload.year;
      state.data = action.payload.data;
      state.is_filtered = action.payload.is_filtered;
    },
    resetAccruals: (state) => {
      state.year = null;
      state.data = [];
      state.is_filtered = false;
    },
  },
});

export const { setAccruals, resetAccruals } = allAccrualsSlice.actions;

export default allAccrualsSlice.reducer;
